import { render, staticRenderFns } from "./PrescriptionInput.vue?vue&type=template&id=915c2f8e"
import script from "./PrescriptionInput.vue?vue&type=script&lang=js"
export * from "./PrescriptionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports